import { useEffect, useState, useMemo } from 'react';
import { useDispatch } from '@betty/toolkit/state';
import useUserDetails from './useUserDetails';
import { fetchFullAddress } from '../utils';
import { FullAddress } from '../components/AddressField/AddressField.types';

export const useUserFullAddress = () => {
  const dispatch = useDispatch();
  const { userDetails } = useUserDetails();
  const [fullAddress, setFullAddress] = useState<FullAddress | null>(null);
  const [isAddressLoaded, setIsAddressLoaded] = useState(false);

  const addressString = useMemo(() => {
    if (
      !userDetails ||
      !userDetails.addressLine1 ||
      !userDetails.city ||
      !userDetails.province ||
      !userDetails.postalCode
    ) {
      return '';
    }
    return `${userDetails.addressLine1} ${userDetails.city}, ${userDetails.province}, ${userDetails.postalCode}`;
  }, [userDetails]);

  useEffect(() => {
    let isMounted = true;

    const loadAddress = async () => {
      const retrieved = await fetchFullAddress(dispatch, addressString);
      if (isMounted) {
        setFullAddress(retrieved);
        setIsAddressLoaded(true);
      }
    };

    if (addressString) {
      loadAddress();
    } else {
      setIsAddressLoaded(true);
    }

    return () => {
      isMounted = false;
    };
  }, [addressString, dispatch]);

  const returnObj = useMemo(
    () => ({
      fullAddress,
      isAddressLoaded,
    }),
    [fullAddress, isAddressLoaded],
  );

  return returnObj;
};

export default useUserFullAddress;
